module.exports = __webpack_public_path__ + "img/kleisma2m.d3aff28e.jpg";